import {
  loadOrderCalculateTotal,
  loadOrderCalculateTotalWithTaxes
} from 'modules/orders/hooks'
import { unwrapCalculateTotalResponse } from 'utils'

type RecalculateOrderTotalsParams = {
  orderTypeId?: string
  customerId?: string
  unityId?: string
  paymentTermId?: string
  items: any[]
  totalDiscount: number
  totalExpenses: number
  freightPrice: number
}

export async function recalculateOrderTotals(
  params: RecalculateOrderTotalsParams
) {
  const {
    orderTypeId,
    customerId,
    unityId,
    paymentTermId,
    items,
    totalDiscount,
    totalExpenses,
    freightPrice
  } = params

  if (!items?.length) return null

  if (orderTypeId === 'P') {
    const response = await loadOrderCalculateTotal({
      isTaxesRecalculePending: true,
      totalDiscount,
      totalExpenses,
      freightPrice,
      items
    })

    return unwrapCalculateTotalResponse(response)
  }

  if (!customerId || !unityId || !paymentTermId || !orderTypeId) {
    return null
  }

  const response = await loadOrderCalculateTotalWithTaxes({
    customerId,
    invoiceTypeId: orderTypeId,
    unityId,
    paymentTerm: paymentTermId,
    items,
    totalDiscount,
    totalExpenses,
    freightPrice
  })

  return unwrapCalculateTotalResponse(response)
}
